export { default } from "./BaseSwitch";
